import { Facebook, Music2, Image, Ghost, Search } from "lucide-react";

export const CHANNELS = {
  meta: { name: "Meta Ads", sub: "Facebook & Instagram", color: "#1877F2", Icon: Facebook },
  tiktok: { name: "TikTok Ads", sub: "Spark Ads & Reels", color: "#00c9d4", Icon: Music2 },
  pinterest: { name: "Pinterest Ads", sub: "Épingles Shopping", color: "#E60023", Icon: Image },
  snapchat: { name: "Snapchat Ads", sub: "Formats verticaux", color: "#eab308", Icon: Ghost },
  google: { name: "Google Ads", sub: "Performance Max", color: "#4285F4", Icon: Search },
};

export const ChannelBadge = ({ id, size = 36 }) => {
  const c = CHANNELS[id];
  if (!c) return null;
  const { Icon } = c;
  return (
    <div
      className="rounded-xl flex items-center justify-center shrink-0"
      style={{ width: size, height: size, background: `${c.color}22`, border: `1px solid ${c.color}55` }}
      title={c.name}
      data-testid={`channel-badge-${id}`}
    >
      <Icon style={{ color: c.color }} size={size * 0.5} />
    </div>
  );
};
